// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { checkDot16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-check-dot': IconCheckDot;
    }
}

/**
 * The icon component for the 'checkDot' icon
 */
export class IconCheckDot extends IconSvg {
    public constructor() {
        super(checkDot16X16);
    }
}

registerIconSvg('icon-check-dot', IconCheckDot);
export const iconCheckDotTag = 'nimble-icon-check-dot';
